import types from '../../constants';

const initialState = {
  selectedUnit: [],
  selectedLocation: '',
};

const UnitViewReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.EXERCISE_RUN_UNIT_SELECT:
      return {
        ...state,
        selectedUnit: action.payload,
      };
    case types.EXERCISE_RUN_LOCATION_SELECT:
      return {
        ...state,
        selectedLocation: action.payload,
      };
    case types.EXERCISE_CLEAR:
      return initialState;
    default:
      return state;
  }
};

export default UnitViewReducers;
